/**
 * @description Defines the visual strategy for the global loading state of the tree.
 */
export enum TreeLoadingMode {
    /** @description Displays an inline or corner spinner. */
    Icon = 'icon',

    /** @description Displays a semi-transparent overlay (mask) over the tree viewport. */
    Mask = 'mask'
}

/**
 * @description Presentation of the global loading state for the tree viewport.
 */
export type ITreeLoadingMode = 'icon' | 'mask';